// const expStyleVar = {
//     cfHorizontalAlignment: 'start' | 'end' | 'center';
//     cfVerticalAlignment: 'start' | 'end' | 'center';
//     cfMargin: string;
//     cfPadding: string;
//     cfBackgroundColor: string;
//     cfWidth: string;
//     cfMaxWidth: string;
//     cfHeight: string;
//     cfFlexDirection: 'row' || 'column';
//     cfFlexWrap: 'nowrap' | 'wrap';
//     cfBorder: string;
//     cfBorderRadius: string;
//     cfGap: string;
//     cfHyperlink: string;
//     cfImageAsset: OptimizedImageAsset | string;
//     // cfImageOptions: ImageOptions;
//     // cfBackgroundImageUrl: OptimizedBackgroundImageAsset | string;
//     // cfBackgroundImageOptions: BackgroundImageOptions;
//     cfOpenInNewTab: boolean;
//     cfFontSize: string;
//     cfFontWeight: string;
//     cfLineHeight: string;
//     cfLetterSpacing: string;
//     cfTextColor: string;
//     cfTextAlign: 'left' | 'center' | 'right';
//     cfTextTransform: 'none' | 'capitalize' | 'uppercase' | 'lowercase';
//     cfTextBold: boolean;
//     cfTextItalic: boolean;
//     cfTextUnderline: boolean;
//     cfColumns: string;
//     cfColumnSpan: string;
//     cfColumnSpanLock: boolean;
//     cfWrapColumns: boolean;
//     cfWrapColumnsCount: string;
// }

import { inBuiltStyles, setAttr } from "@/helpers/contentful.helper";
import { camelCaseToWords, deepCopy } from "@/helpers/utils.helper";
import { content } from "./bpCompContent";
import { T_KeyValue } from "@/types/app.type";



// variant: {
//     displayName: 'Variant',
//     type: 'Text',
//     defaultValue: 'dark',
//     group: 'style',
//     validations: {
//         in: [{ value: 'light' }, { value: 'dark' }]
//     }
// }

const design: T_KeyValue = {
    cfPadding: setAttr({
        displayName: 'Padding',
        defaultValue: "0 0 0 0",
    }),
    // variant: setAttr({
    //     displayName: 'Variant',
    //     type: 'Text',
    //     defaultValue: 'primary',
    //     validations: [
    //         { value: 'primary' }, 
    //         { value: 'secondary' }, 
    //         { value: 'body' },
    //         { value: 'success' },
    //         { value: 'danger' },
    //         { value: 'warning' },
    //         { value: 'info' },
    //         { value: 'light' },
    //         { value: 'dark' },
    //         { value: 'white' },
    //         { value: 'transparent' },
    //         { value: 'black' }
    //     ]
    // })
}

export const variables: T_KeyValue = {
    content: {},
    design: {}
}

function convertToObj(a: string[], b: any[]) {
    if (a.length != b.length || 
        a.length == 0 || 
        b.length == 0) {
        return null;
    }

    // Using reduce() method
    let object = a.reduce((acc: any, element: string, index: number) => {
        return {
            ...acc,
            [[
                "",
                // "modalVariant", 
                // "successMessage",
                // "subTitle",
                // "externalUrl"
            ].includes(element) ? element?.toLocaleLowerCase() : element]: b[index],
        };
    }, {});

    return object;
}

export const getVariablesFor = (component: string) => {
    return { ...content?.common || {}, ...(()=>{
        // debugger
        // console.log("Component ---- ", content);
        const obj = content?.[component];
        if(!obj) { return {} }
        return convertToObj(Object.keys(obj), Object.values(obj)) || obj;
    })() || {}, ...design || {} }
}

export const defineAttributes = (obj: T_KeyValue) => {
    let newObj: T_KeyValue = {};
    // obj = { width: "100px", height: "100px" }
    for(const key in obj) {
        const dVal = deepCopy(obj[key]);
        
        // const inBuildKey = inBuiltStyles[key];
        // cfPadding: {
        //     displayName: 'Padding',
        //     type: 'Text',
        //     defaultValue: "0 0 0 0",
        //     group: "style",
        //   },
        if(inBuiltStyles[key]) {
            newObj[inBuiltStyles[key]] = setAttr(
                {
                    displayName: camelCaseToWords(key),
                    defaultValue: dVal,
                    ...(()=>dVal ? {defaultValue: dVal} : {})()
                }
            );
            // console.log("attr 11 --- ", obj, key, dVal, newObj);
        } else {
            newObj[key] = setAttr(
                {
                    displayName: camelCaseToWords(key),
                    ...(()=>dVal ? {defaultValue: dVal} : {})()
                }
            );
        }
        
    }
    // console.log("attr --- ", obj, newObj);
    return newObj;
}


export const animationVariables: any = {
    animated: {
      displayName: "Animation",
      type: 'Boolean',
      defaultValue: false,
      group: 'style'
    },
    animationType: {
      displayName: "Animation type",
      type: 'Text',
      defaultValue: "",
      group: 'style',
      validations: {
        in: [
          {value: 'fade-in', displayName: 'Fade in'},
          {value: 'fade-down', displayName: 'Fade down'},
          {value: 'fade-up', displayName: 'Fade up'},
          {value: 'fade-left', displayName: 'Fade left'},
          {value: 'fade-right', displayName: 'Fade right'},
          {value: 'flip-left', displayName: 'Flip left'},
          {value: 'flip-right', displayName: 'Flip right'},
          {value: 'flip-up', displayName: 'Flip up'},
          {value: 'flip-down', displayName: 'Flip down'}
        ]
      }
    }
  }